// UK phone numbers, said one way (Oct 2026, Chris's review L19): three suppliers' numbers were
// written three ways, and one read "01onal234567". A UK number is tidied when it's saved
// ("07700 900123", "020 7946 0000", "01632 960123"); anything else is kept as typed, with a
// word that it doesn't look like a number. Nothing is refused: a supplier abroad is fine.

const digitsOf = (s) => String(s || '').replace(/[^\d+]/g, '');

//: A number with anything but digits and the marks people write them with — a name, "ask
//: for Dave", "ext two-oh-four". Tidying stripped those to digits and gave back the number
//: alone, so the note was deleted the first time anyone tabbed through the box.
const HAS_WORDS = /[^\d+()\-.\s]/;

//: The twelve four-figure area codes — 0113–0118, 0121, 0131, 0141, 0151, 0161, 0191 —
//: which are dialled 4-3-4. Everything else on 01 really is five and six.
const FOUR_FIGURE = /^0(1\d1|11\d)/;

/** The number as it's shown and saved. */
export function tidyPhone(raw) {
  const s = String(raw || '').trim();
  if (!s) return '';
  if (HAS_WORDS.test(s)) return s;
  let d = digitsOf(s);
  let uk = false;
  if (d.startsWith('+44')) { d = `0${d.slice(3)}`; uk = true; }
  else if (d.startsWith('0044')) { d = `0${d.slice(4)}`; uk = true; }
  // Only where +44 was taken off: "0045 12 34 56 78" is Denmark, not "04512 345678".
  if (uk && /^00\d{10}$/.test(d)) d = d.slice(1);   // +44 (0)20 7946 0000, as it's usually written
  if (!/^0\d{10}$/.test(d)) return s;
  if (/^0[2]/.test(d)) return `${d.slice(0, 3)} ${d.slice(3, 7)} ${d.slice(7)}`;   // 020 7946 0000
  if (/^0(3|8|9)/.test(d)) return `${d.slice(0, 4)} ${d.slice(4, 7)} ${d.slice(7)}`; // 0300 123 4567
  if (FOUR_FIGURE.test(d)) return `${d.slice(0, 4)} ${d.slice(4, 7)} ${d.slice(7)}`; // 0161 496 0000
  return `${d.slice(0, 5)} ${d.slice(5)}`;                                            // 07700 900123, 01632 960123
}

/** Why a number looks wrong, or null: letters in it, or too few digits to dial. */
export function phoneProblem(raw) {
  const s = String(raw || '').trim();
  if (!s) return null;
  if (/[a-z]/i.test(s.replace(/\b(ext|x)\.?\s*\d+$/i, ''))) return "That has letters in it: is it the right number?";
  if (digitsOf(s).replace('+', '').length < 7) return 'That looks too short to be a phone number';
  return null;
}
